import { createExternalStore, Storage } from '@iheartjane/utils';
import { useSyncExternalStore } from 'react';

/**
 * The shopper's pick, re-sent on cart writes. The cart's `group_special_id` is
 * only what applied, and is null whenever no line qualifies.
 */
type GroupSpecialId = number;

const GROUP_SPECIAL_SELECTION_KEY = 'cart-group-special-selection';

const { notify, subscribe } = createExternalStore();

const readSelections = (): Record<string, GroupSpecialId> =>
  Storage.get<Record<string, GroupSpecialId>>(GROUP_SPECIAL_SELECTION_KEY) ??
  {};

export const getGroupSpecialSelection = (
  cartUuid: string | null | undefined
): GroupSpecialId | null => (cartUuid && readSelections()[cartUuid]) || null;

/** Keyed by cart uuid, so a new cart starts with no selection. */
export const setGroupSpecialSelection = (
  cartUuid: string,
  groupSpecialId: GroupSpecialId | null
) => {
  const { [cartUuid]: _cleared, ...otherCarts } = readSelections();
  const selections =
    groupSpecialId === null
      ? otherCarts
      : { ...otherCarts, [cartUuid]: groupSpecialId };

  if (Object.keys(selections).length) {
    Storage.set(GROUP_SPECIAL_SELECTION_KEY, selections);
  } else {
    Storage.remove(GROUP_SPECIAL_SELECTION_KEY);
  }

  notify();
};

export const useGroupSpecialSelection = (cartUuid: string | null | undefined) =>
  useSyncExternalStore(
    subscribe,
    () => getGroupSpecialSelection(cartUuid),
    () => null
  );
